import * as React from 'react';
import {withStyles,
  WithStyles,
  StyleRules
} from '@mui/styles';
import {Theme} from '@mui/styles';
import RelationField from '~common/components/relation-field';
import CookieManager from '~common/lib/cookie-manager';
import Pager from '../components/query-fulfillment/query-list-pager';
import {IconButton, Chip, InputLabel, Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Paper} from '@mui/material';
import EmptySet from '../components/empty-set';
import { values } from 'lodash';
import Renderers from '~common/lib/renderers';



const styles = (theme: Theme): StyleRules => ({
  container: {
  },
  relationListArea: {
    padding:15
  },
  relationItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  relationItemText: {
    flexGrow: 4
  },
  itemDelete: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
    // fontSize: '0.90rem'
  },
  pagerArea: {
    display: 'flex',
    flexDirection: 'row-reverse'
  },
  pager: {},
  chip: {
    margin: `${theme.spacing(.1)}px ${theme.spacing(.25)}px`,
  },
});


type RelList = {
  activeText: string
  relations: Array<any>
}


interface Props extends React.HTMLProps<HTMLDivElement> {
  value: RelList;
  title: string
  relationType?: string
  mode: string
  autoSuggestURL: string;
  fieldDefinition: any;
  relations: any;
  error?: any;
  onRelationChange: Function;
  customRenderers?: any;
  customMessages?: any;
  appendToQuery?: Array<any>;
  
}

type State = {
  value: any;
  chipOverride?: boolean;
  // if using paging
  currentPage: number;
  pageSize: number;
};

class RelationList extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, props);
    let initVal:RelList = {
      activeText: "",
      relations:[]
    }
    

    if(props && props.value && props.value.relations){
      initVal.relations = props.value.relations
    }
    

    var pageSize: any = 5;
    var ps = CookieManager.getCookie(
      `relationListPageSize|${window.location.pathname}`
    );
    if (ps != '') {
      pageSize = Number(ps);
      if (isNaN(pageSize)) {
        pageSize = undefined;
      }
    }
    if(props && props.fieldDefinition && props.fieldDefinition.pageSize) {
      pageSize = props.fieldDefinition.pageSize
    }

    this.state = {
      value: initVal,
      pageSize: pageSize,
      currentPage: 0
    };

  }

  handleProps = (newProps: any) =>  {
    if (newProps && newProps.value && newProps.value.relations !== undefined) {
        this.setState({value: newProps.value})
        
    // } else if (newProps && !newProps.value) {

    //   this.setState({value: newProps.value})
    }
  }

  UNSAFE_componentWillReceiveProps( newProps: Props & WithStyles<keyof typeof styles>) {
    var value = newProps.value

    if (!value) {
      value = {}
    }
    this.setState({
      value: value,
      displayValue: newProps.displayValue || value.label || ""
    });

  }

 componentDidMount(props: Props & WithStyles<keyof typeof styles>) {
    this.handleProps(props)
  }

  handleRelationAdd = (relation: any) => {
    const {value, pageSize} = this.state;
    const {path, onChangeAtPath, onRelationChange, fieldDefinition} = this.props;

    var fieldValue = {
      relations: null,
      activeText: "",
    }
    if (value) {
      fieldValue = value
    }

    var rel = []
    if(fieldValue && fieldValue.relations ){
      rel = fieldValue.relations 
    }

    if(relation && relation.value){
      if(fieldDefinition.relationType){
        relation["type"] = fieldDefinition.relationType
      }
      rel.push(relation)

    }

    
    fieldValue.relations = rel
    fieldValue.activeText = ""

    var maxPage = Math.floor(rel.length / pageSize)
    if ((rel.length % pageSize) == 0) {
      maxPage--
    }

    this.setState({value:fieldValue, currentPage:maxPage}, ()=>{
      if(onChangeAtPath){
        onChangeAtPath(path, fieldValue)
      }
      if(onRelationChange){
        onRelationChange(fieldValue)
      }
    })

  }

  handleItemDelete = (idx: number) => () => {
    const {value, currentPage, pageSize} = this.state;
    const {path, onChangeAtPath, onRelationChange} = this.props;

    value.relations = value.relations.filter(function(value, arrIndex) {
      return idx !== arrIndex;
    });
    var newPage = currentPage
    const maxPage = (value.relations.length/pageSize)
    if (currentPage >= maxPage && currentPage != 0) {
      newPage = currentPage-1
    }

    this.setState({value:value, currentPage:newPage}, ()=>{
      if(onChangeAtPath){
        onChangeAtPath(path, value)
      }
      if(onRelationChange){
        onRelationChange(value)
      }
    })

  }

  onToggleChip = () => {
    this.setState({chipOverride: !this.state.chipOverride})
  }

  handleChangePage = (newPage: number, newPageSize: number) => {
    const { pageSize } = this.state;
    if (pageSize != newPageSize) {
      // if the page size is changed, go back to page 1
      newPage = 0;
    }

    this.setState({ currentPage: newPage, pageSize: newPageSize }, () => {
      // save pageSize to cookie
      CookieManager.setCookie(
        `relationListPageSize|${window.location.pathname}`,
        String(newPageSize),
        30
      );
    });
  };

  buildHeader = (relations: Array<any>, listAttributes: any) => {
    var {columns} = listAttributes
    if (columns && columns.length > 0) {
      return (
        <TableRow>
          {columns.map((c:any)=>{
            return (<TableCell>{c.label}</TableCell>)
          })}
          <TableCell></TableCell>
      </TableRow>
      )
    }
  }

  buildRows = (relations: Array<any>, listAttributes: any, pager?: any) => {
    const { disabled } = this.props
    const { classes }: {classes: ClassNameMap} = this.props
    const {currentPage, pageSize} = this.state
    var {columns} = listAttributes
    if (relations && relations.length > 0) {
      return relations.map((r:any, idx)=>{
        let includeInDisplay =
        !pager ||
        (idx >= currentPage * pageSize &&
          idx < currentPage * pageSize + pageSize);
        if (includeInDisplay) {
          return (
            <TableRow>
              {columns && columns.map((c:any, idx)=>{
                if (c.key == "label") {
                  return  (<TableCell>{r.value["label"] || r.label}</TableCell>)
                } else {
                  return (<TableCell>{r.value[c.key]}</TableCell>)
                }
              })}
              {!disabled && <TableCell>
                <IconButton
                  size="small"
                  aria-label="delete"
                  className={classes.itemDelete}
                  onClick={this.handleItemDelete(idx)}>
                  <i className="fa fas fa-trash" />
                </IconButton>
            </TableCell>}
            </TableRow>
          )
        }
       
      })
    }
  }

  renderTable = (relations: Array<any>, listAttributes: any, pager?: any) => {
    
    if (!relations || (relations && relations.length == 0)) {
      return null
    }

    var header = this.buildHeader(relations, listAttributes)
    var rows = this.buildRows(relations, listAttributes, pager)

    return (
      <div>
        <TableContainer component={Paper}>
            <Table>
            <TableHead>
              {header}
            </TableHead>
            <TableBody>
                {rows}
            </TableBody>
            </Table>
        </TableContainer>
         {pager && <div style={{float: "right"}}>{pager}</div>}
      </div>
      
    )
  }

  render() {
    const { classes }: {classes: ClassNameMap} = this.props
    const { disabled } = this.props
    const {value, displayValue, chipOverride, currentPage, pageSize} = this.state
    const {autoSuggestURL, fieldDefinition, helpText, title, mode, error, appendToQuery} = this.props
    
    let useChips = (fieldDefinition.variant && fieldDefinition.variant.toLowerCase() == 'chips')
    var fieldValue = null
    if (value) {
      fieldValue = value
    }


    var rel = []
    if(fieldValue && fieldValue.relations ){
      rel = fieldValue.relations 
    }
    var activeText = ""
    if(fieldValue && fieldValue.activeText ){
      activeText = fieldValue.activeText 
    }


    var subfieldDisabled = disabled 
    if (fieldDefinition.maxLength && rel.length >= fieldDefinition.maxLength) {

      subfieldDisabled = true
    }

      
    if ( useChips && !chipOverride) {
      let chipLimit = 3
      if (fieldDefinition && fieldDefinition.chipAttributes && fieldDefinition.chipAttributes.chipLimit) {
        chipLimit = fieldDefinition.chipAttributes.chipLimit
      }
      let chips = rel.map((relation:any, idx:any)=>{
          let itemCount = rel.length - chipLimit +1
          if (idx+1 == chipLimit && itemCount != 1){
            return (
              <Chip
              key={idx}
              tabIndex={-1}
              size={"small"}
              label={"+"+itemCount+" more..."}
              className={classes.chip}
              clickable={true}
              onClick={this.onToggleChip}
              onDelete={this.handleItemDelete(idx)}
              />
            )
          } else if (idx >= chipLimit && chipLimit != -1 ) {
            return
          } else {
            return (
              <Chip
              key={idx}
              tabIndex={-1}
              size={"small"}
              label={relation.label}
              className={classes.chip}
              onDelete={this.handleItemDelete(idx)}
            />
            )
          }
        
      })
      return (
        <div>
        <RelationField 
          title={title}
          disabled={subfieldDisabled}
          helpText={helpText}
          onToggleChip={this.onToggleChip}
          autoSuggestURL={autoSuggestURL}
          fieldDefinition={fieldDefinition}
          mode={mode}
          error={error}
          chips={chips}
          useChips={useChips}
          onRelationUpdate={this.handleRelationAdd}
          value={activeText}
          excluded={rel}
          appendToQuery={appendToQuery}
        />
        </div>
      );

    } else {

      var pager = null;
      var usePaging = (fieldDefinition.pagerThreshold && rel.length > fieldDefinition.pagerThreshold && (!useChips || chipOverride))
      if (usePaging) {
        pager = (
          <div className={classes.pagerArea}>
            <div className={classes.pager}>
              <Pager
                page={currentPage}
                pageSize={pageSize || 5}
                count={rel.length || 0}
                onChangePage={this.handleChangePage}
                pageSizeOptions={[5, 10, 20]}
              />
            </div>
          </div>
        );
      }

      var ListRenderer
      if ((fieldDefinition.relationListAttributes || {}).listRenderer) {
        ListRenderer = Renderers.find(fieldDefinition.relationListAttributes.listRenderer)
      }

      var listAttributes = fieldDefinition.relationListAttributes

      return (
        <div>

          {!disabled && <RelationField 
            disabled={subfieldDisabled}
            title={title}
            helpText={helpText}
            autoSuggestURL={autoSuggestURL}
            onToggleChip={this.onToggleChip}
            fieldDefinition={fieldDefinition}
            mode={mode}
            useChips={useChips}
            error={error} 
            onRelationUpdate={this.handleRelationAdd}
            value={activeText}
            excluded={rel}
            appendToQuery={appendToQuery}
          />}

         {disabled && <InputLabel>
            {fieldDefinition.title}
          </InputLabel>}
          

          {!ListRenderer && (!listAttributes || (listAttributes && !listAttributes.columns)) && <div className={classes.relationListArea}>

            { rel.map((relation:any, idx:any)=>{
            let includeInDisplay =
            !usePaging ||
            (idx >= currentPage * pageSize &&
              idx < currentPage * pageSize + pageSize);
              if (includeInDisplay) {
                return (
                  <div style={{padding: disabled ? 5 : 0}} className={classes.relationItem} key={idx}>
                        <div>{relation.label}</div>
                        {!disabled && <IconButton
                          aria-label="delete"
                          size="small"
                          className={classes.itemDelete}
                          onClick={this.handleItemDelete(idx)}>
                          <i className="fa fas fa-trash" />
                        </IconButton>}
                  </div>
                )
              }
            })}

          {pager}
          </div>}

          {!ListRenderer && (listAttributes && listAttributes.columns) && this.renderTable(rel, listAttributes, pager)}

          {ListRenderer && 
            <div>
              <ListRenderer relations={rel} handleItemDelete={this.handleItemDelete} />
            </div>
          }
        
        </div>
      );
    }
  }
}

export default withStyles(styles)(RelationList);
